export const PUBSUB = {
  SHOW_SHIPPING_ADDRESS: 'ShowShippingAddress',
  SAVE_SELECTED_ADDRESS: 'SaveSelectedAddress',
  ADD_NEW_ADDRESS: 'AddNewAddress',
  SHOW_SUBSCRIPTION_PAYMENT: 'ShowSubscriptionPayment',
  ADD_SUBSCRIPTION_PAYMENT: 'AddNewPayment',
  SAVED_SUBSCRIPTION_PAYMENT: 'SavedSubscriptionPayment',
  GET_ALL_ADDRESS_API: 'GetAllAddressApi',
  GET_ALL_PAYMENT_API: 'GetAllPaymentApi',
  REDIRECT_TO_SUBSCRIPTION_OVERRIDE_CART_PAGE:
    'RedirectToSubscriptionOverrideCartPage',
  INTERNAL_ROUTING: 'InternalRouting',
  SIGN_OUT: 'SignOut',
  RESET_PASSWORD: 'ResetPassword',
  SHOW_CATALOG_PAGE_MYSITE_REDESIGN: 'ShowCatalogPage',
  SELECTED_PRODUCTS_ARRAY_MYSITE_REDESIGN: 'SelectedProductsArray',
  FILTERS_SORT_PAGE_UPDATED_MYSITE_REDESIGN: 'FiltersUpdated',
  MAX_SELECTED_PRODUCTS_CAP: 'MaxSelectedProductsCap',
  ADD_TO_CART: 'AddToCart',
  ACCOUNT_CONVERSION: 'AccountConversion',
  BA_CONVERSION_COMPLETED: 'BAConversionCompleted',
  DIRECT_SELLER_PRODUCT: 'DirectSellerProduct',
  NON_HOME_MARKET: 'NonHomeMarket',
  PROMO_CODE_APPLY_REMOVE_EVENT: 'PromoCodeApplyRemoveEvent',
  ADD_TO_CART_FAILURE: 'AddToCartFailure',
  TOGGLE_MINI_CART: 'ToggleMiniCart',
  MINI_CART_CLOSED: 'MiniCartClosed',
  CART_COUNT_UPDATED: 'CartCountUpdated',
  CART_DATA_UPDATED: 'CartDataUpdated',
  NAVIGATE_TO_VIEW_CART: 'NavigateToViewCart',
  CUSTOMER_PROFILE_UPDATED: 'CustomerProfileUpdated',
  PERSONAL_OFFER_DISCOUNT: 'PersonalOfferDiscount',
  PERSONAL_OFFER_DISCOUNT_REQUEST: 'PersonalOfferDiscountRequest',
  PERSONAL_OFFER_BUY_NOW: 'POBuyNow',
  PERSONAL_OFFER_SHOW_AUTH_POPUP: 'POShowAuthPopup',
  SHOW_NOTIFY_DIRECT_SELLER_POPUP: 'ShowNotifyDirectSellerPopup',
  PO_SHOW_NO_OFFER_HERE: 'POShowNoOfferHere',
  ORDER_PLACED: 'OrderPlaced',
}
